Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.NewSessionModalView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/new_session_modal']
  className: 'modal start-new-session-modal'

  events:
    'change select' : 'updateStartButton'
    'click #explore': 'onClickExplore'
    'click #review': 'onClickReview'
    'click #analysis': 'onClickAnalysis'
    'click .dashboard-modes button': 'onModeChange'

  initialize: ({
    @mustShowAnalysisButton
    @uuid
    @sortedAvailableChannelsByProvider
  }) ->
    @selectedProvider = null
    @selectedChannelUids = []
    @publicationsNewSessionView = new Monitoring.Views.SocialContents.NewSession.PublicationsView(@sortedAvailableChannelsByProvider)
    @publicationsNewSessionView.on('updateSelectedChannels', @updateSelectedChannels)

  render: ->
    @$el.html @template
      mustShowAnalysisButton: @mustShowAnalysisButton
      uuid: @uuid
      sortedAvailableChannelsByProvider: @sortedAvailableChannelsByProvider
    @$el.find('.select-channel').html @publicationsNewSessionView.render().el
    @

  canSearch: =>
    if @inAnalysisMode()
      @hasSelectedAnyChannel()
    else
      @selectedTopics() and @inTopicMode()

  updateSelectedChannels: (selection) =>
    @selectedProvider = selection.provider
    @selectedChannelUids = selection.channel_uids
    @updateStartButton()

  getSelectedChannelsWith: (availableChannels) =>
    availableChannels.filter( (availableChannel) =>
      @selectedChannelUids.includes(availableChannel.uid)
    )

  setSelections: ->
    @changeContentSelect(@activeMode())

  onClickExplore: =>
    @$el.find('#search_social_contents_btn').addClass('explore').removeClass('review')

  onClickReview: =>
    @$el.find('#search_social_contents_btn').addClass('review').removeClass('explore')

  onClickAnalysis: =>
    @$el.find('#search_social_contents_btn').removeClass('review').removeClass('explore')

  onModeChange: (evt) =>
    mode = $(evt.currentTarget).attr('id')
    @changeContentSelect(mode)

  updateStartButton: =>
    @enableSearchButton()

  changeContentSelect: (mode) ->
    @$el.find('#mode-selectors > div').addClass('hidden')
    @$el.find(@_selector(mode)).removeClass('hidden')
    @enableSearchButton()

  enableSearchButton: ->
    @$el.find('#search_social_contents_btn').toggleClass('disabled', not @_shouldEnableSearchButton())

  _shouldEnableSearchButton: ->
    return true if @inTopicMode() and @selectedTopics()
    @inAnalysisMode() and @hasSelectedAnyChannel()

  hasSelectedAnyChannel: ->
    @selectedChannelUids.length > 0

  selectedTopics: ->
    @$el.find('.select-view .tags .label').length > 0

  inTopicMode: ->
    @inReviewMode() || @inExploreMode()

  inReviewMode: ->
    @activeMode() == 'review'

  inExploreMode: ->
    @activeMode() == 'explore'

  inAnalysisMode: ->
    @activeMode() == 'analysis'

  inSurveyMode: ->
    @activeMode() == 'survey'

  activeMode: ->
    @$el.find('.dashboard-modes button.active').attr('id')

  _selector: (mode) ->
    switch mode
      when 'analysis' then return '.select-channel'
      when 'survey' then return '.select-survey'
      else return '.select-topic'

  remove: ->
    @publicationsNewSessionView.remove()
    super()
